/**
 * 了解宇乐树
 */

export default [
    {
        path: '/ylsInfoUnderstand',
        name: 'ylsInfoUnderstand',
        component: () => import('../../views/understand/ylsInfoUnderstand.vue'),
        meta: {
            title: '了解宇乐树'
        }
    },
    {
        path: '/ylsCareerUnderstand',
        name: 'ylsCareerUnderstand',
        component: () => import('../../views/understand/ylsCareerUnderstand.vue'),
        meta: {
            title: '宇乐树生涯科技研究院'
        }
    },
    {
        path: '/parterPlanUnderstand',
        name: 'parterPlanUnderstand',
        component: () => import('../../views/understand/parterPlanUnderstand.vue'),
        meta: {
            title: '合作伙伴计划'
        }
    },
    {
        path: '/joinUsUnderstand',
        name: 'joinUsUnderstand',
        component: () => import('../../views/understand/joinUsUnderstand.vue'),
        meta: {
            title: '加入我们'
        }
    },
    {
        path: '/parterDialog',
        name: 'parterDialog',
        component: () => import('../../views/understand/parterDialog.vue'),
        meta: {
            title: '扫二维码'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/understand/understand.js